import React from "react";
import { Icon } from "@iconify/react";
import { HStack, VStack, getCompanyName } from "../../../../components/utils";
import Tooltip from "../../../../components/shared/Tooltip";
import { downloadBlobObject } from "../../../../utils/DownloadFile";

type Props =
  | { s3url: string; base64?: never }
  | { base64: string; s3url?: never };

export default function RepricingReportDownload({ s3url, base64 }: Props) {
  const companyName = getCompanyName();

  const handleDownload = async () => {
    let blob: Blob;
    if (base64) {
      const byteCharacters = atob(base64);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    } else {
      blob = await (await fetch(s3url!)).blob();
    }
    downloadBlobObject(blob, `Repricing_Report_${companyName}.xlsx`);
  };

  return (
    <Tooltip text="Click to download Report">
      <div className="cursor-pointer" onClick={handleDownload}>
        <HStack className="items-center">
          <Icon icon="mdi:file-excel" width={32} color="#51A687" />
          <VStack className="gap-0.5">
            <p className="text-sm font-semi-medium hover:text-red-600 underline">
              Repricing_Summary.xlsx
            </p>
            <p className="text-sm font-semi-medium text-gray-light">
              Repricing Summary Report
            </p>
          </VStack>
        </HStack>
      </div>
    </Tooltip>
  );
}
